import { Input } from '@/components/ui/input';

export function SidebarNavSearchInput({
  value,
  onChange,
  placeholder = 'Search navigation…',
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}) {
  return (
    <div className="tw:px-3 tw:pb-1">
      <Input
        type="search"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        aria-label="Search navigation"
        className="tw:h-8"
      />
    </div>
  );
}
